<template>
  <!-- <div class="text-tooltip"> -->
    <el-tooltip
      class="commonEllipsisTooltip"
      popper-class="commonEllipsisTooltip"
      :effect="effect"
      :disabled="isShowTooltip || isDisabled"
      :content="content"
      :placement="placement"
      v-bind="$attrs"
      v-on="$listeners"
    >
      <span v-if="customContent">
        <slot name="default"></slot>
      </span>
      <p
        class="over-flow"
        :class="['W100', className]"
        @mouseover="onMouseOver(refName)"
        v-else
      >
        <span :ref="refName">
          <template>{{ content || "--" }}</template>
        </span>
      </p>
    </el-tooltip>
  <!-- </div> -->
</template>

<script>
export default {
  name: "commonEllipsisTooltip",
  props: {
    // 显示的文字内容
    content: {
      type: String,
      default: () => {
        return "";
      },
    },
    // 外层框的样式，在传入的这个类名中设置文字显示的宽度
    className: {
      type: String,
      default: () => {
        return "";
      },
    },
    // 为页面文字标识（如在同一页面中调用多次组件，此参数不可重复）
    refName: {
      type: String,
      default: () => {
        return "";
      },
    },
    // 背景风格
    effect: {
      type: String,
      default: () => {
        return "dark";
      },
    },
    // 显示位置
    placement: {
      type: String,
      default: () => {
        return "top";
      },
    },
    hide: {
      type: Boolean,
      default: false
    },
    customContent: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      isShowTooltip: true,
      isDisabled: false
    };
  },
  watch: {
    hide() {
      this.init()
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.init()
    })
  },
  methods: {
    onMouseOver(str) {
      let parentWidth = this.$refs[str].parentNode.offsetWidth;
      let contentWidth = this.$refs[str].offsetWidth;
      // 判断是否开启tooltip功能
      if (contentWidth > parentWidth) {
        this.isShowTooltip = false;
      } else {
        this.isShowTooltip = true;
      }
    },
    init() {
      if (this.hide) {
        if (this.$refs[this.refName]) {
          let parentWidth = this.$refs[this.refName].parentNode.offsetWidth;
          let contentWidth = this.$refs[this.refName].offsetWidth;
          this.isDisabled = Boolean(contentWidth <= parentWidth)
          return null
        }
      }
      if (this.customContent) {
        this.isShowTooltip = false;
      }
      this.isDisabled = false
    }
  },
};
</script>

<style lang="scss" scoped>
.over-flow {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.W100 {
  width: 100%;
}
p {
  margin: 0;
}
</style>
